<page-with-permissions-wrapper>
  <div>
    <release-details [version$]="version$" *ngIf="isOkStatus$ | async"></release-details>
    <p *ngIf="!(isOkStatus$ | async)">Unknown error has occurred. May be you are trying opening a wrong version.</p>
  </div>
</page-with-permissions-wrapper>
